import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";import { CatalogPaginationRequest } from "src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "src/app/features/shared/models/Filter/FilterRequest";
import { ControlPanelAPIService } from "src/app/features/shared/services/API/ControlPanelAPI.service";
;

@Injectable({
  providedIn: "root",
})
export class ControlPanelService {
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();

  public isAlarmListVisible: boolean = false;
  public listDialogRef: any;

  subscription_GetAlarms: Subscription;

  constructor(private controlPanelService: ControlPanelAPIService) {
  }

setLoading(resp) {
  this.isLoading$.next(resp);
}

getLoading() {
  return this.isLoading$.asObservable();
}



getResume(month: number): any {
  return this.controlPanelService.getResume(month);
}


//paginacion
getFilterValues(request : FilterRequest[]) {
  return this.controlPanelService.getFilterValues(request);
}

getPage(request : CatalogPaginationRequest) {
  return this.controlPanelService.getPage(request);
}
getCount(request : CatalogPaginationRequest) {
  return this.controlPanelService.getCount(request);
}
  
}
